import React, { useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import emailjs from "emailjs-com";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";

const InquiryForm2 = () => {
  const [captchaToken, setCaptchaToken] = useState(null);
  const captchaRef = useRef();
  const refform = useRef();

  const [popup, setPopup] = useState({ visible: false, message: "", type: "" });
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("+1");
  const [message, setMessage] = useState("");

  const handleCaptchaChange = (token) => setCaptchaToken(token);

  const sendForm = (e) => {
    e.preventDefault();

    if (!name) return showPopup("Please enter your name.", "error");
    if (!email) return showPopup("Please enter your email.", "error");
    if (!phone || phone.length < 5) return showPopup("Please enter a valid phone number.", "error");
    if (!message) return showPopup("Please enter a message.", "error");
    if (!captchaToken) return showPopup("Google reCAPTCHA verification failed, please try again later.", "error");

    setLoading(true);

    emailjs
      .sendForm("service_yuejhee", "template_lvjfdfa", refform.current, "EPaxZziu0shHpbDkS")
      .then(() => {
        setLoading(false);
        showPopup("Thank you for contacting us. We will get back to you shortly!", "success");
      })
      .catch(() => {
        setLoading(false);
        showPopup("An error occurred while submitting the form.", "error");
      });
  };

  const showPopup = (message, type) => {
    setPopup({ visible: true, message, type });
  };

  const handlePopupClose = () => {
    setPopup({ visible: false, message: "", type: "" });
    window.location.reload();
  };

  return (
    <>
      {/* Loader */}
      {loading && (
        <div className="popup-overlay">
          <div className="loader"></div>
        </div>
      )}

      {/* Popup Modal */}
      {popup.visible && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-icon">
              {popup.type === "success" ? (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                  <circle style={{ fill: "#25AE88" }} cx="25" cy="25" r="25" />
                  <polyline
                    style={{
                      fill: "none",
                      stroke: "#FFFFFF",
                      strokeWidth: "2",
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeMiterlimit: "10",
                    }}
                    points="38,15 22,33 12,25"
                  />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                  <circle style={{ fill: "#D75A4A" }} cx="25" cy="25" r="25" />
                  <polyline
                    style={{
                      fill: "none",
                      stroke: "#FFFFFF",
                      strokeWidth: "2",
                      strokeLinecap: "round",
                      strokeMiterlimit: "10",
                    }}
                    points="16,34 25,25 34,16"
                  />
                  <polyline
                    style={{
                      fill: "none",
                      stroke: "#FFFFFF",
                      strokeWidth: "2",
                      strokeLinecap: "round",
                      strokeMiterlimit: "10",
                    }}
                    points="16,16 25,25 34,34"
                  />
                </svg>
              )}
            </div>
            <h4 className={popup.type === "success" ? "text-success" : "text-danger"}>
              {popup.type === "success" ? "Success!" : "Error!"}
            </h4>
            <p>{popup.message}</p>
            <button className="btn btn-secondary mt-3" onClick={handlePopupClose}>
              OK
            </button>
          </div>
        </div>
      )}

      <section id="form" className="container-fluid py-5">
        <div className="col-11 col-md-5 mx-auto">
          <div className="text-center">
            <form ref={refform} onSubmit={sendForm} id="contactForm" method="POST">
              <div className="form-group my-3 mt-md-0 mb-3">
                <div className="w-100">
                  <input
                    type="text"
                    className="form-control py-2"
                    name="name"
                    placeholder="Your Name*"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="mt-3" />
                <div className="w-100">
                  <input
                    type="email"
                    className="form-control py-2"
                    name="email"
                    placeholder="Email*"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="w-100">
                  <PhoneInput
                    country={"us"}
                    value={phone}
                    onChange={(phone) => setPhone(phone)}
                    className="form-control py-1"
                  />
                  <input type="hidden" name="phone_number" value={phone} />
                </div>
              </div>
              <div className="form-group mt-3">
                <textarea
                  className="col-pri form-control py-2"
                  name="message"
                  rows="4"
                  placeholder="Write Message*"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
              </div>
              <div className="text-start mt-4">
                <ReCAPTCHA
                  sitekey="6LeyzboqAAAAAGcQxKRIM1R2A8sv3rxXSGrfIUnv"
                  onChange={handleCaptchaChange}
                  ref={captchaRef}
                />
                <div>
                  <button
                    type="submit"
                    className="w-100 fw-500 mt-4 rounded-3 border-0 text-white fs-ss-20 py-2 bg-ss-primary"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Popup & Loader CSS */}
      <style jsx>{`
        .popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }
        .popup-box {
          background: white;
          padding: 20px 30px;
          border-radius: 10px;
          text-align: center;
          max-width: 400px;
          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
        }
        .popup-box .btn-secondary{
        width:100px;
        }
        .popup-icon {
         display: flex;
         align-items: center;
         justify-content: center;
        }
        .popup-icon svg {
          width: 75px;
          height: 75px;
          margin-bottom: 20px;
        }
        .loader {
          border: 6px solid #f3f3f3;
          border-top: 6px solid #3498db;
          border-radius: 50%;
          width: 60px;
          height: 60px;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </>
  );
};

export default InquiryForm2;
